<template>
  <v-row class="d-flex justify-space-between">
    <v-col
      xs="12"
      sm="6"
      md="6"
      lg="3"
    >
      <avs-card
        noTitle
        class="text-center pt-4"
        outlined
        elevation="1"
        tile
        height="100%"
      >
        <template v-slot:content>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle class="secondary--text text-h6 font-weight-bold">
                {{ $t("categories.inspection.all_inspections") }}
              </v-list-item-subtitle>
              <span class="primary--text text-h4 font-weight-bold">{{ inspectionsCount }}</span>
            </v-list-item-content>
          </v-list-item>
        </template>
      </avs-card>
    </v-col>
    <v-col
      xs="12"
      sm="6"
      md="6"
      lg="3"
    >
      <avs-card
        noTitle
        class="text-center pt-4"
        outlined
        elevation="1"
        tile
        height="100%"
        ><template v-slot:content>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle class="secondary--text text-h6 font-weight-bold">
                {{ $t("categories.inspection.ongoing") }}
              </v-list-item-subtitle>
              <span class="primary--text text-h4 font-weight-bold">{{
                inspectionsOnGoingCount
              }}</span>
            </v-list-item-content>
          </v-list-item>
        </template>
      </avs-card>
    </v-col>
    <v-col
      xs="12"
      sm="6"
      md="6"
      lg="3"
    >
      <avs-card
        noTitle
        class="text-center pt-4"
        outlined
        elevation="1"
        tile
        height="100%"
        ><template v-slot:content>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle class="secondary--text text-h6 font-weight-bold">
                {{ $t("categories.inspection.without_nc") }}
              </v-list-item-subtitle>
              <span class="primary--text text-h4 font-weight-bold">{{
                inspectionsWthNcCount
              }}</span>
            </v-list-item-content>
          </v-list-item>
        </template>
      </avs-card>
    </v-col>
    <v-col
      xs="12"
      sm="6"
      md="6"
      lg="3"
    >
      <avs-card
        noTitle
        class="text-center pt-4"
        outlined
        elevation="1"
        tile
        height="100%"
        ><template v-slot:content>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle class="secondary--text text-h6 font-weight-bold">
                {{ $tc("categories.nonconformity.name", 2) }}
              </v-list-item-subtitle>
              <span class="primary--text text-h4 font-weight-bold">{{ nonConformitiesCount }}</span>
            </v-list-item-content>
          </v-list-item>
        </template>
      </avs-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "KPIStatistics",
  props: {
    inspections: {
      type: Array
    },
    nonConformities: {
      type: Array
    }
  },
  data() {
    return {
      inspectionsCount: 0,
      inspectionsOnGoingCount: 0,
      inspectionsWthNcCount: 0,
      nonConformitiesCount: 0
    }
  },
  mounted() {
    this.handleKPI()
  },
  methods: {
    handleKPI() {
      this.inspectionsCount = this.inspections.length
      this.inspectionsOnGoingCount = this.inspections.filter(
        item => item.status == "Ongoing"
      ).length
      this.inspectionsWthNcCount = this.inspections.filter(item => item.children == 0).length
      this.nonConformitiesCount = this.nonConformities.length
    }
  },
  watch: {
    inspections: {
      handler() {
        this.handleKPI()
      }
    }
  }
}
</script>
